<template>
  <v-alert
    v-if="isStale"
    type="warning"
    colored-border
    border="left"
    elevation="2"
    prominent
  >
    <div class="float-left">
      <h4>Refresh Required</h4>
      <div>{{ message }}</div>
    </div>
    <v-btn
      class="float-right"
      color="primary"
      @click="refresh"
      :loading="loading"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
  </v-alert>
</template>

<script>
export default {
  name: 'StaleDataAlert',
  props: {
    isStale: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: 'This data has been updated by another user. Please refresh to see updated data.'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    }
  }
};
</script>
